import React from 'react';

const EmptyState = ({ type = 'search', searchQuery = '', onClearFilter }) => {
  const isSearchEmpty = type === 'search';
  
  return (
    <div className="absolute inset-0 flex items-center justify-center bg-gray-50/80 backdrop-blur-sm z-10">
      <div className="text-center max-w-md mx-auto p-8">
        {/* Icon */}
        <div className="mb-6">
          {isSearchEmpty ? (
            <svg className="w-20 h-20 text-gray-400 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          ) : (
            <svg className="w-20 h-20 text-gray-400 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          )}
        </div>

        {/* Title */}
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">
          {isSearchEmpty ? 'No results found' : 'No mementos yet'}
        </h2>

        {/* Description */}
        <p className="text-gray-600 mb-6 leading-relaxed">
          {isSearchEmpty ? (
            <>
              We couldn't find any mementos matching <span className="font-medium text-gray-800">"{searchQuery}"</span>.
              <br />
              Currently using simple text search - AI search coming soon!
            </>
          ) : (
            <>
              Your knowledge graph is empty. Once you start adding mementos,
              <br />
              they'll appear here as an interconnected network of ideas.
            </>
          )}
        </p>

        {/* Actions */}
        <div className="space-y-3">
          {isSearchEmpty ? (
            <button
              onClick={onClearFilter}
              className="inline-flex items-center px-6 py-3 bg-brand-500 hover:bg-brand-600 text-white font-medium rounded-xl transition-colors duration-200 shadow-sm"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
              </svg>
              Show all mementos
            </button>
          ) : (
            <div className="text-sm text-gray-500">
              Start a conversation or import your data to begin building your knowledge graph
            </div>
          )}
        </div>

        {/* Tips */}
        <div className="mt-8 pt-6 border-t border-gray-200">
          <h3 className="text-sm font-medium text-gray-700 mb-3">
            {isSearchEmpty ? 'Search tips:' : 'Getting started:'}
          </h3>
          <ul className="text-sm text-gray-600 space-y-2 text-left">
            {isSearchEmpty ? (
              <>
                <li className="flex items-start">
                  <span className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  Try broader search terms
                </li>
                <li className="flex items-start">
                  <span className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  Search by topics, categories, or content
                </li>
                <li className="flex items-start">
                  <span className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  Use the help guide for more tips
                </li>
              </>
            ) : (
              <>
                <li className="flex items-start">
                  <span className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  Add mementos through conversations
                </li>
                <li className="flex items-start">
                  <span className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  Import your existing notes and data
                </li>
                <li className="flex items-start">
                  <span className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  Use the help guide to learn more
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default EmptyState;
